import { Analytics } from './Analytics';
import amplitude from 'amplitude-js';
import { Event } from './Event';
import { Events } from './Events';

const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY || '';

export class Amplitude extends Analytics {
  unsupportedEvents = [Events.PageView];

  supportedEvents = Object.values(Events).filter(
    (event) => !this.unsupportedEvents.includes(event),
  );

  constructor() {
    super();
    amplitude.getInstance().init(AMPLITUDE_API_KEY, undefined, {
      includeUtm: true,
      includeReferrer: true,
      includeGclid: true,
    });
  }

  static amplitudeId = amplitude.options.userId;

  static setUserProperty(name: string, value: any) {
    amplitude.getInstance().setUserProperties({
      [name]: value,
    });
  }

  static setUserId(id: string) {
    amplitude.getInstance().setUserId(id);
  }

  trackEvent(event: Event) {
    amplitude.getInstance().logEvent(event.name, event.params);
  }
}
